import {Login} from "../components/login/Login";
import React from "react";

const LoginPage = () => (
    <div>
        <Login/>
    </div>
);

export default LoginPage;
